import axios from "axios";
import Config from '../../../config/config'
import {
    CREATE_ROLE_ERROR, CREATE_ROLE_REQUEST, CREATE_ROLE_SUCCESS,
    DELETE_ROLE_ERROR,
    DELETE_ROLE_REQUEST,
    UPDATE_ROLE_SUCCESS,
    UPDATE_ROLE_REQUEST,
    UPDATE_ROLE_ERROR,
    DELETE_ROLE_SUCCESS,
    GET_ROLE_ERROR, GET_ROLE_REQUEST, GET_ROLE_SUCCESS
} from "../actiontypes";
import { notificationFail, notificationSuccess } from "../notificationMsg";

export const getRoles = (column_name = "", type = "") => {
    const loggedInUser = localStorage.getItem('token').replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(getRolesRequest())
        await axios.get(`${Config.API_URL}api/organization/get-all-role`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${loggedInUser}`
            }
        }).then(response => {
            const data = response.data
            if (data.status === true) {
                dispatch(getRolesSuccess(data))
            } else {
                dispatch(getRolesError(data))
            }
        }).catch(error => {
            dispatch(getRolesError(error))
        })
    }
}

export const getRolesRequest = () => {
    return {
        type: GET_ROLE_REQUEST
    }
}
export const getRolesSuccess = (data) => {
    return {
        type: GET_ROLE_SUCCESS,
        payload: data
    }
}
export const getRolesError = (error) => {
    return {
        type: GET_ROLE_ERROR,
        payload: error
    }
}

// --------------------------------


export const createRoles = (data) => {
    const loggedInUser = localStorage.getItem("token")?.replace(/['"]+/g, "");
    return async (dispatch) => {
        dispatch(createRolesRequest());

        try {
        const response = await axios.post(
            `${Config.API_URL}api/organization/add-role`,
            data,
            {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${loggedInUser}`,
            },
            }
        );

        const resData = response.data;

        if (resData.status === true) {
            dispatch(createRolesSuccess(resData));
            dispatch(notificationSuccess(resData.message || "Role created successfully"));
            return { success: true, data: resData, message: resData.message };
        } else {
            dispatch(createRolesError(resData));
            dispatch(notificationFail(resData.message || "Failed to create role"));
            return { success: false, error: resData.message || "Failed to create role" };
        }
        } catch (error) {
        const message =
            error?.response?.data?.message || "Something went wrong, please try again.";
        dispatch(createRolesError(message));
        dispatch(notificationFail(message));
        return { success: false, error: message };
        }
    };
};


export const createRolesRequest = () => {
    return {
        type: CREATE_ROLE_REQUEST
    }
}
export const createRolesSuccess = (data) => {
    return {
        type: CREATE_ROLE_SUCCESS,
        payload: data
    }
}
export const createRolesError = (error) => {
    return {
        type: CREATE_ROLE_ERROR,
        payload: error
    }
}
//Update roles ----------------------

export const updateRoles = (data) => {
    const loggedInUser = localStorage.getItem('token')?.replace(/['"]+/g, '');
    return async (dispatch) => {
        dispatch(updateRoleRequest());
        try {
            const response = await axios.post(`${Config.API_URL}api/organization/updates-role`, data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${loggedInUser}`
                }
            });
            const resData = response.data;
            if (resData.status === true) {
                dispatch(updateRolesSuccess(resData.data));
                dispatch(notificationSuccess(resData.message));
                return { success: true, data: resData.data, message: resData.message };
            } else {
                dispatch(updateRolesError(resData.message));
                dispatch(notificationFail(resData.message));
                return { success: false, error: resData.message };
            }
        } catch (error) {
            console.error("Error is there:", error);
            const errorMessage = error?.response?.data?.message || 'Something went wrong';
            dispatch(updateRolesError(errorMessage));
            dispatch(notificationFail(errorMessage));
            return { success: false, error: errorMessage };
        }
    };
};

export const updateRoleRequest = () => {
    return {
        type: UPDATE_ROLE_REQUEST
    }
}
export const updateRolesSuccess = (data) => {
    return {
        type: UPDATE_ROLE_SUCCESS,
        payload: data
    }
}
export const updateRolesError = (error) => {
    return {
        type: UPDATE_ROLE_ERROR,
        payload: error
    }
}
// ----------------------------------

// -------------------------------------

export const deleteRoles = (role_id) => {
    const loggedInUser = localStorage.getItem("token")?.replace(/['"]+/g, "");
    return async (dispatch) => {
        dispatch(deleteRolesRequest());

        try {
        const response = await axios.delete( `${Config.API_URL}api/organization/delete-role/${role_id}`,{
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${loggedInUser}`,
                },
            }
        );

        const data = response.data;

        if (data.status === true) {
            dispatch(deleteRolesSuccess(data));
            dispatch(notificationSuccess(data.message));
            return { success: true, data: data.data, message: data.message }; // ✅ return here
        } else {
            dispatch(deleteRolesError(data.message));
            dispatch(notificationFail(data.message));
            return { success: false, error: data.message }; // ✅ return here
        }
        } catch (error) {
        const errorMessage =
            error?.response?.data?.message || "Something went wrong";
        dispatch(deleteRolesError(errorMessage));
        dispatch(notificationFail(errorMessage));
        return { success: false, error: errorMessage }; // ✅ return here
        }
    };
};


export const deleteRolesRequest = () => {
    return {
        type: DELETE_ROLE_REQUEST
    }
}
export const deleteRolesSuccess = (data) => {
    return {
        type: DELETE_ROLE_SUCCESS,
        payload: data
    }
}
export const deleteRolesError = (error) => {
    return {
        type: DELETE_ROLE_ERROR,
        payload: error
    }
}